export const processEnv = window.__env__ || process.env;
processEnv.NODE_ENV = process.env.NODE_ENV;
